export default __webpack_public_path__ + "assets/payment-icons/mastercard.846eaa71de1660047e90d4bfa65dc87b.svg";